import { call, put, takeLatest } from 'redux-saga/effects';
import { Map, List } from 'immutable';
import { Notification } from '@utils';
import {
  getConexoes as getConexoesSdk,
  getConexao as getConexaoSdk,
  postConexao as postConexaoSdk,
  putConexao as putConexaoSdk,
} from '@sdk/Conectores/Conexoes';

//Action Types
export const Types = {
  GET_CONEXOES: 'GET_CONEXOES',
  GET_CONEXOES_SUCCESS: 'GET_CONEXOES_SUCCESS',
  GET_CONEXOES_ERROR: 'GET_CONEXOES_ERROR',

  GET_CONEXAO: 'GET_CONEXAO',
  GET_CONEXAO_SUCCESS: 'GET_CONEXAO_SUCCESS',
  GET_CONEXAO_ERROR: 'GET_CONEXAO_ERROR',

  POST_CONEXAO: 'POST_CONEXAO',
  POST_CONEXAO_SUCCESS: 'POST_CONEXAO_SUCCESS',
  POST_CONEXAO_ERROR: 'POST_CONEXAO_ERROR',

  PUT_CONEXAO: 'PUT_CONEXAO',
  PUT_CONEXAO_SUCCESS: 'PUT_CONEXAO_SUCCESS',
  PUT_CONEXAO_ERROR: 'PUT_CONEXAO_ERROR',

  RESET_CONEXOES: 'RESET_CONEXOES',
};

//Action Creators
export const getConexoes = (idConfiguracao) => ({ type: Types.GET_CONEXOES, idConfiguracao });
export const getConexoesSuccess = (data) => ({ type: Types.GET_CONEXOES_SUCCESS, data });
export const getConexoesError = (error) => ({ type: Types.GET_CONEXOES_ERROR, error });

export const getConexao = (idConfiguracao, id) => ({ type: Types.GET_CONEXAO, idConfiguracao, id });
export const getConexaoSuccess = (data) => ({ type: Types.GET_CONEXAO_SUCCESS, data });
export const getConexaoError = (error) => ({ type: Types.GET_CONEXAO_ERROR, error });

export const postConexao = (data) => ({ type: Types.POST_CONEXAO, data });
export const postConexaoSuccess = () => ({ type: Types.POST_CONEXAO_SUCCESS });
export const postConexaoError = (error) => ({ type: Types.POST_CONEXAO_ERROR, error });

export const putConexao = (data) => ({ type: Types.PUT_CONEXAO, data });
export const putConexaoSuccess = () => ({ type: Types.PUT_CONEXAO_SUCCESS });
export const putConexaoError = (error) => ({ type: Types.PUT_CONEXAO_ERROR, error });

export const reset = () => ({ type: Types.RESET_CONEXOES });

//saga
function* fetchGetConexoes(action) {
  try {
    const { idConfiguracao } = action;
    const conexoes = yield call(getConexoesSdk, idConfiguracao);
    yield put(getConexoesSuccess(conexoes));
  } catch (err) {
    Notification.error(err.message);
    yield put(getConexoesError(err));
  }
}

function* fetchGetConexao(action) {
  try {
    const { idConfiguracao, id } = action;
    const conexao = yield call(getConexaoSdk, idConfiguracao, id);
    yield put(getConexaoSuccess(conexao));
  } catch (err) {
    Notification.error(err.message);
    yield put(getConexaoError(err));
  }
}

function* fetchPostConexao(action) {
  try {
    const { data } = action;
    yield call(postConexaoSdk, data);
    yield put(postConexaoSuccess());
  } catch (err) {
    Notification.error(err.message);
    yield put(postConexaoError(err));
  }
}

function* fetchPutConexao(action) {
  try {
    const { data } = action;
    yield call(putConexaoSdk, data);
    yield put(putConexaoSuccess());
  } catch (err) {
    Notification.error(err.message);
    yield put(putConexaoError(err));
  }
}

export const saga = [
  takeLatest(Types.GET_CONEXOES, fetchGetConexoes),
  takeLatest(Types.GET_CONEXAO, fetchGetConexao),
  takeLatest(Types.POST_CONEXAO, fetchPostConexao),
  takeLatest(Types.PUT_CONEXAO, fetchPutConexao),
];

// Reducer
const initialState = Map({
  conexoes: List(),
  conexao: {},

  loadingConexoes: false,
  successConexoes: false,
  errorConexoes: false,

  loadingConexao: false,
  successConexao: false,
  errorConexao: false,

  postingConexao: false,
  successPostConexao: false,
  errorPostConexao: false,

  putingConexao: false,
  successPutConexao: false,
  errorPutConexao: false,
});

const handleGetConexoes = (state, action) => {
  return state.set('loadingConexoes', true).set('successConexoes', false).set('errorConexoes', false);
};

const handleGetConexoesSuccess = (state, action) => {
  const conexoes = action.data;

  return state.set('conexoes', List(conexoes)).set('loadingConexoes', false).set('successConexoes', true).set('errorConexoes', false);
};

const handleGetConexoesError = (state, action) => {
  return state.set('loadingConexoes', false).set('successConexoes', false).set('errorConexoes', action.error);
};

const handleGetConexao = (state, action) => {
  return state.set('loadingConexao', true).set('successConexao', false).set('errorConexao', false);
};

const handleGetConexaoSuccess = (state, action) => {
  const conexao = action.data[0];
  return state.set('conexao', conexao).set('loadingConexao', false).set('successConexao', true).set('errorConexao', false);
};

const handleGetConexaoError = (state, action) => {
  return state.set('loadingConexao', false).set('successConexao', false).set('errorConexao', action.error);
};

const handlePostConexao = (state, action) => {
  return state.set('postingConexao', true).set('successPostConexao', false).set('errorPostConexao', false);
};

const handlePostConexaoSuccess = (state, action) => {
  return state.set('postingConexao', false).set('successPostConexao', true).set('errorPostConexao', false);
};

const handlePostConexaoError = (state, action) => {
  return state.set('postingConexao', false).set('successPostConexao', false).set('errorPostConexao', action.error);
};

const handlePutConexao = (state, action) => {
  return state.set('putingConexao', true).set('successPutConexao', false).set('errorPutConexao', false);
};

const handlePutConexaoSuccess = (state, action) => {
  return state.set('putingConexao', false).set('successPutConexao', true).set('errorPutConexao', false);
};

const handlePutConexaoError = (state, action) => {
  return state.set('putingConexao', false).set('successPutConexao', false).set('errorPutConexao', action.error);
};

const handleReset = (state, action) => {
  state = initialState;
  return state;
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.GET_CONEXOES:
      return handleGetConexoes(state, action);
    case Types.GET_CONEXOES_SUCCESS:
      return handleGetConexoesSuccess(state, action);
    case Types.GET_CONEXOES_ERROR:
      return handleGetConexoesError(state, action);

    case Types.GET_CONEXAO:
      return handleGetConexao(state, action);
    case Types.GET_CONEXAO_SUCCESS:
      return handleGetConexaoSuccess(state, action);
    case Types.GET_CONEXAO_ERROR:
      return handleGetConexaoError(state, action);

    case Types.POST_CONEXAO:
      return handlePostConexao(state, action);
    case Types.POST_CONEXAO_SUCCESS:
      return handlePostConexaoSuccess(state, action);
    case Types.POST_CONEXAO_ERROR:
      return handlePostConexaoError(state, action);

    case Types.PUT_CONEXAO:
      return handlePutConexao(state, action);
    case Types.PUT_CONEXAO_SUCCESS:
      return handlePutConexaoSuccess(state, action);
    case Types.PUT_CONEXAO_ERROR:
      return handlePutConexaoError(state, action);

    case Types.RESET_CONEXOES:
      return handleReset(state, action);

    default:
      return state;
  }
}
